import { XMarkIcon } from "@heroicons/react/16/solid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideToast } from "../app/store/statusSlice";
import { RootState } from "../app/store/store";

const Toast = () => {
  const { message, type } = useSelector(
    (state: RootState) => state.status.toast,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const hideToastTimeout = type === "info" ? 9000 : 5000;

    if (message) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, hideToastTimeout);

      return () => clearTimeout(timer);
    }
  }, [message, dispatch, type]);

  if (!message) {
    return null;
  }

  const toastStyle = (() => {
    switch (type) {
      case "success":
        return "alert-success";
      case "error":
        return "alert-error";
      case "info":
        return "alert-info";
      default:
        return "alert";
    }
  })();

  const handleClose = () => {
    dispatch(hideToast());
  };

  return (
    <div className="toast pointer-events-none z-10 w-full items-center justify-center">
      <div
        className={`alert ${toastStyle} pointer-events-auto flex grow items-center justify-between text-wrap text-white`}
      >
        <span className="grow text-center">{message}</span>
        <button
          className="btn btn-sm btn-circle btn-ghost ml-2"
          onClick={handleClose}
          type="button"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Toast;
